module.exports = __webpack_public_path__ + "img/footer-3_en.0b8baf3.jpg";